import styles from "./SupportConfirmationScreen.module.scss";

import { useLocation, useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { AppButton } from "@/modules/shared/components/AppButton";
import { PageContainer } from "@/modules/shared/components/PageContainer";
import { ROUTES } from "@/modules/shared/consts/routes";
import { CheckIcon } from "@/modules/shared/svgs/CheckIcon";

export const SupportConfirmationScreen = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isEmbedRoute = location.pathname.startsWith("/embed");

  const handleFinish = () => {
    const supportPath = isEmbedRoute
      ? ROUTES.support.embed.index
      : ROUTES.support.index;
    navigate({ to: supportPath });
  };

  return (
    <PageContainer variant="fullWidth">
      <div className={isEmbedRoute ? styles.wrapperEmbed : styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.illustration}>
            <CheckIcon className={styles.checkIcon} />
          </div>

          <div className={styles.textWrapper}>
            <h1 className={styles.title}>{t("needHelp.confirmation.title")}</h1>
            <p className={styles.description}>
              {t("needHelp.confirmation.description")}
            </p>
          </div>

          <AppButton variant="critical" onClick={handleFinish}>
            {t("needHelp.confirmation.finishButton")}
          </AppButton>
        </div>
      </div>
    </PageContainer>
  );
};
